<script setup lang="ts">
import { twMerge } from "tailwind-merge";

import { ShapeStrokeColors } from "~/telestrations/constants/colors";
import { TELESTRATION_TOOLTIP_CONTAINER } from "~/telestrations/constants/tooltip";

const { t } = useI18n();
const shapesStore = useShapesStore();
const isMenuOpened = ref(false);

const options = computed(() => {
  if (shapesStore.selectedShape) {
    return ShapeStrokeColors[shapesStore.selectedShape.type];
  }

  return [];
});
const selectedStrokeColor = computed(() => {
  if (shapesStore.selectedShape) {
    return shapesStore.selectedShape.stroke as string;
  }

  return options.value[0];
});

const inputClasses = computed(() =>
  twMerge(
    "!border-none !gap-x-2 px-1.5",
    isMenuOpened.value ? "!bg-neutral-light-100 dark:!bg-neutral-dark-500" : "hover:!bg-neutral-light-100 dark:hover:!bg-neutral-dark-500"
  )
);

function onShow() {
  isMenuOpened.value = true;
}

function onHide() {
  isMenuOpened.value = false;
}

function onShapeStrokeChange(value: string) {
  if (!shapesStore.selectedShape) {
    return;
  }

  shapesStore.updateShape(shapesStore.selectedShape, { stroke: value });
}
</script>

<template>
  <template v-if="options.length">
    <USelectMenu
      v-model="selectedStrokeColor"
      :options="options"
      :input-class="inputClasses"
      list-class="grid grid-cols-2 p-2 gap-x-1 gap-y-2"
      variant="inline"
      :divider="false"
      :hide-trailing-icon="true"
      :render-in-portal="false"
      item-class="min-h-max rounded"
      container-class="p-1"
      @show="onShow"
      @hide="onHide"
      @update:model-value="onShapeStrokeChange"
    >
      <template #option="{ option }">
        <div class="rounded-full border-2 p-0.5" :style="{ borderColor: selectedStrokeColor === option.value ? selectedStrokeColor : 'transparent' }">
          <div class="size-6 rounded-full" :style="{ backgroundColor: option.value }" />
        </div>
      </template>
      <UIcon
        v-tooltip="{
          content: t('labels.change_stroke_color'),
          container: TELESTRATION_TOOLTIP_CONTAINER,
        }"
        name="stroke-color"
        class="size-6"
        :style="{ backgroundColor: selectedStrokeColor }"
      />
    </USelectMenu>
  </template>
</template>
